import { createSvgIcon } from '../../createSvgIcon';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const
};

export const SettingsIcon = createSvgIcon(
  <>
    <path
      d="M12.7941 15.3954C12.3216 15.5911 11.8151 15.6919 11.3036 15.6919C10.2706 15.6919 9.27991 15.2815 8.54947 14.5511C7.81902 13.8206 7.40866 12.8299 7.40866 11.7969C7.40866 10.7639 7.81902 9.77323 8.54947 9.04278C9.27991 8.31234 10.2706 7.90198 11.3036 7.90198C11.8151 7.90198 12.3216 8.00272 12.7941 8.19846C13.2667 8.3942 13.6961 8.6811 14.0578 9.04278C14.4194 9.40446 14.7063 9.83384 14.9021 10.3064C15.0978 10.779 15.1986 11.2854 15.1986 11.7969C15.1986 12.3084 15.0978 12.8149 14.9021 13.2875C14.7063 13.76 14.4194 14.1894 14.0578 14.5511C13.6961 14.9128 13.2667 15.1997 12.7941 15.3954Z"
      {...strokeProps}
    />
    <path
      d="M21.5516 15.333C21.0929 16.6522 20.3846 17.8708 19.4652 18.9223L17.006 18.3642C16.0733 19.2007 14.9652 19.8179 13.7629 20.1704L13.0983 22.5775C12.4753 22.6892 11.8439 22.747 11.211 22.7501C10.4192 22.751 9.62988 22.6616 8.85831 22.4838L8.15319 19.999C7.10232 19.6117 6.13631 19.0247 5.30839 18.2704L2.87694 18.8956C1.91267 17.7688 1.18887 16.4567 0.75 15.04L2.54464 13.0463C2.38085 12.0266 2.40794 10.9854 2.62453 9.97568L0.854205 8.12893C1.36883 6.68037 2.18448 5.35725 3.24745 4.24672L5.75994 4.87195C6.45178 4.31724 7.22251 3.86886 8.04667 3.5416L8.71126 1.08236C9.53212 0.869782 10.3759 0.758191 11.2238 0.750061C11.9011 0.750061 12.5784 0.812584 13.2442 0.935314L13.8821 3.38182C14.8431 3.69327 15.7439 4.16914 16.5405 4.7909L19.0669 4.13904C20.0862 5.16631 20.8904 6.38653 21.4324 7.72832L19.7188 9.58896C20.0438 10.864 20.0707 12.1968 19.7975 13.4839L21.5516 15.333Z"
      {...strokeProps}
    />
  </>,
  { displayName: 'SettingsIcon', viewBox: '0 0 23 24' }
);
